<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nom" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="prenom" class="font-light" >Prenom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.prenom" placeholder="Doe" name="prenom" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="debut" class="font-light" >Début congé<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.startDate" placeholder="" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="fin" class="font-light" >Fin congé<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.endDate" placeholder="" name="fin" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="heure" class="font-light" >Heure de reprise<span class="text-[#f44545]">*</span></label>
                    <input type="time" v-model="form.returnTime" placeholder="" name="heure" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                    <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Enregistrer</span>
                    </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <h2 class="text-xl font-bold text-center mb-4">FORMULAIRE DE DEMANDE DE CONGES</h2>

                <!-- <div class="mb-4 text-black">
                    <h3 class="text-2xl font-medium mb-6 underline">SECTION I</h3>
                    <table class="border border-black w-full border-collapse">
                        <thead>
                            <tr class="w-full">
                                <th scope="row" colspan="2" class="border">
                                    <p class="font-normal">Nom : </p>
                                    <p class="font-normal">Fonction : </p>
                                </th>
                                <th>
                                    <p class="font-normal">Date d'embauche</p>
                                </th>
                            </tr>
                            <tr class="w-full">
                                <th>
                                    <p class="font-normal">text : </p>
                                </th>
                                <th>
                                    <p class="font-normal">text : </p>
                                </th>
                            </tr>
                            <tr class="w-full">
                                <th>
                                    <p class="font-normal">text : </p>
                                </th>
                                <th>
                                    <p class="font-normal">text : </p>
                                </th>
                                <th>
                                    <p class="font-normal">text : </p>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>

                <div class="mb-4 text-black">
                    <h3 class="text-lg font-semibold mb-2">SECTION I</h3>
                    <table class="form-table">
                        <tr>
                            <th>Nom:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Fonction:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Date d'embauche:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Département:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Date:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Les jours du congé:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Date de début:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Date de fin:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Type de congé:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>La personne pour gérer les questions pendant mon absence sera:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Date:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Signature:</th>
                            <td></td>
                        </tr>

                    </table>
                </div> -->

                <!-- <div class="mb-4">
                    <h3 class="text-lg font-semibold mb-2">Approbation Hiérarchie</h3>
                    <table class="form-table">
                        <tr>
                            <th>Nom:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Date:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Signature:</th>
                            <td></td>
                        </tr>
                    </table>
                </div> -->

                <!-- <div class="mb-4">
                    <h3 class="text-lg font-semibold mb-2">Approbation DRH</h3>
                    <table class="form-table">
                        <tr>
                            <th>Nom:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Date:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Signature:</th>
                            <td></td>
                        </tr>
                    </table>
                </div> -->

                <!-- <div class="mb-4">
                    <h3 class="text-lg font-semibold mb-2">SECTION II</h3>
                    <table class="form-table">
                        <tr>
                            <th>Solde annuel en cours:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Nombre de jour demand:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Nouveaux rapports annuels:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Balance d'urgence courante:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>No de jour pris:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Nouveau balance Obligatoire:</th>
                            <td></td>
                        </tr>
                    </table>
                </div> -->

                <!-- <div class="mb-4">
                    <h3 class="text-lg font-semibold mb-2">Approbation Directeur</h3>
                    <table class="form-table">
                        <tr>
                            <th>Date:</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Signature:</th>
                            <td></td>
                        </tr>
                    </table>
                </div> -->

                <div class="mt-8 text-center text-gray-700">
                    <p>LA LOCOMOTIVE (SARLU) Société au capital d'UN MILLION 1.000.000 de FCFA</p>
                    <p>CC:1847932 J / RC/ CI-ABJ-2018-B-24483, sise Abidjan-Cocody les deux-plateaux, Angré nouveau-CHU BP 995 Abidjan 27, Tél. : 05 46 66 77 66.</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "DemandeConge",
    components: {Loader2},
    data(){
        return {
            asSend: false,
            form: {
                nom: null,
                prenom: null,
                startDate: null,
                endDate: null,
                returnTime: null
            }
        }
    },
    methods: {
        clearForm() {
            this.form.nom = null;
            this.form.prenom = null;
            this.form.startDate = null;
            this.form.endDate = null;
            this.form.returnTime = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":3,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    }
}
</script>